import PropTypes from "prop-types";
import { useState } from "react";
import { useDropzone } from "react-dropzone";
import { sendFile, sendMessage, uploadCatalogFile } from "../assets/api/admin/admin_api";

const UploadFile = (props) => {
  const { url, cancel, fileName, uploadType } = props;

  const [selectedFile, setSelectedFile] = useState(null);
  const [msgError, setError] = useState();
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [process, setProcess] = useState(false);
  const [errorFile, setErrorFile] = useState(false);
  const [stats, setStats] = useState(null); 

  const sessionData = JSON.parse(
    localStorage.getItem("tokenSession") || "null"
  );

  const onDrop = (acceptedFiles) => {
    setError("");
    setSelectedFile(acceptedFiles[0]);
  };

  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    maxFiles: 1,
    accept: {
      "text/csv": [
        ".csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values",
      ],
      "application/vnd.ms-excel": [".xls, application/vnd.ms-excel"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ],
    },
  });

  const files = acceptedFiles.map((file) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const close = () => {
    if (cancel) {
      cancel();
    }
  };

const handleOnSubmit = async (e) => {
  e.preventDefault();

  if (!selectedFile) {
    setError("Por favor selecciona un archivo");
    return;
  }

  if (uploadType === 'local') {
    try {
      setSending(true);
      setError("");
      setErrorFile(false);
      setSuccess(false);
      setStats(null);

      const response = await uploadCatalogFile(
        selectedFile, 
        fileName, 
        sessionData?.access_token
      );
      
      if (response.success === false) {
        setError(response.error);
        setStats(response);
        setSending(true);
        setErrorFile(true);
        return;
      }
      
      setSuccess(true);
      setStats(response.stats);
      setSending(true);
      setErrorFile(false);

      if (response.errors && response.errors.length > 0) {
        console.warn('El archivo se procesó pero con errores:');
        response.errors.forEach((error, index) => {
          console.warn(`  ${index + 1}. ${error}`);
        });
      }

      setTimeout(() => {
        if (props.onUploadSuccess) {
          props.onUploadSuccess();
        }
      }, 2000);
      
    } catch (error) {
      console.error('Error inesperado:', error);
      setError(error.message || "Error al procesar el archivo");
      setSending(true); 
      setErrorFile(true);
    }
  } else {
    try {
      setSending(true);
      setError("");
      setErrorFile(false);
      setSuccess(false);

      const uploadResponse = await sendFile(url, selectedFile);

      if (uploadResponse.status === 200 || uploadResponse.status === 201) {
        setProcess(true);

        const messageResponse = await sendMessage(
          sessionData?.access_token,
          fileName
        );

        if (messageResponse.status === 200) {
          setSuccess(true);
          setSending(true);
          
          setTimeout(() => {
            if (props.onUploadSuccess) {
              props.onUploadSuccess();
            }
          }, 2000);
        } else {
          setErrorFile(true);
          setSending(true);
        }
      } else {
        setErrorFile(true);
        setSending(true);
      }
    } catch (error) {
      setError(error.message || "Error al subir el archivo");
      setSending(true); //
      setErrorFile(true);
    }
  }
};
  return (
    <>
   {fileName}
{sending && (
  <>
    <div className="w-full h-auto flex justify-center items-center flex-col gap-4 p-6">

      <div className={`w-full rounded-xl p-4 flex items-center justify-between ${
        !success && !process && !errorFile
          ? "bg-blue-100 border border-blue-300" 
          : errorFile 
            ? "bg-red-100 border border-red-300"
            : "bg-green-100 border border-green-300"
      }`}>
        <p className={`text-md font-medium ${
          !success && !process && !errorFile
            ? "text-blue-700 animate-pulse" 
            : errorFile
              ? "text-red-700"
              : "text-green-700"
        }`}>
          {!success && !process && !errorFile
            ? uploadType === 'local' 
              ? "Procesando archivo Excel..." 
              : "Tu archivo se está subiendo"
            : errorFile
              ? msgError || "Ocurrió un error inesperado, vuelve a intentarlo."
              : uploadType === 'local'
                ? "Archivo procesado correctamente"
                : "Archivo cargado correctamente"}
        </p>

        {!success && !process && !errorFile ? (
          <svg
            aria-hidden="true"
            className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
            viewBox="0 0 100 101"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
              fill="currentColor"
            />
            <path
              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
              fill="currentFill"
            />
          </svg>
        ) : errorFile ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="text-red-600"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="15" y1="9" x2="9" y2="15"></line>
            <line x1="9" y1="9" x2="15" y2="15"></line>
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 50 50"
          >
            <path
              fill="#4caf50"
              d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
            ></path>
            <path
              fill="#ccff90"
              d="M34.602,14.602L21,28.199l-5.602-5.598l-2.797,2.797L21,33.801l16.398-16.402L34.602,14.602z"
            ></path>
          </svg>
        )}
      </div>

      {success && stats && !errorFile && (
        <div className="w-full bg-green-50 border border-green-200 rounded-xl p-4">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-green-700">{stats.inserted}</span>
              <span className="text-xs text-green-600">Insertadas</span>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-blue-700">{stats.updated}</span>
              <span className="text-xs text-blue-600">Actualizadas</span>
            </div>
            <div className="flex flex-col">
              <span className="text-2xl font-bold text-red-700">{stats.deleted}</span>
              <span className="text-xs text-red-600">Eliminadas</span>
            </div>
          </div>
          
          {stats.errors > 0 && (
            <div className="mt-3 pt-3 border-t border-green-200">
              <p className="text-orange-600 text-sm font-medium text-center">
                Errores encontrados: {stats.errors}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  </>
)}
      {!sending && !success && (
        <form onSubmit={handleOnSubmit} className="mt-3">
          <section className="container">
            <div
              {...getRootProps({
                className: `dropzone ${
                  isDragAccept
                    ? "drag-accept"
                    : isDragReject
                    ? "drag-reject"
                    : ""
                }`,
              })}
            >
              <input
                accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                name="file"
                {...getInputProps()}
              />
              <span className="text-3xl">{isDragActive ? "" : ""}</span>
              <p>
                Arrastra y suelta algunos archivos aquí, o haz clic para
                seleccionar un archivo
              </p>
            </div>
            <ul>{files}</ul>
            <p>{msgError}</p>
          </section>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-orange-construrama cancel-btn me-2"
              onClick={() => close()}
            >
              Cancelar
            </button>

            <button
              id="btn-send"
              type="submit"
              className="btn  btn-blue-construrama"
            >
              Agregar
            </button>
          </div>
        </form>
      )}
    </>
  );
};

UploadFile.propTypes = {
  url: PropTypes.node.isRequired,
  fileName: PropTypes.node.isRequired,
  uploadType: PropTypes.string,
  cancel: PropTypes.func,
  onUploadSuccess: PropTypes.func,
};

export default UploadFile;
